import moment from 'moment/moment';
import {Badge} from '../../../../models/badge/badge';
import {AuthSupportPagedList} from '../../../../../swagger-gen/web-secured/models/auth-support-paged-list';
import {AuthSupportType} from '../../../../../swagger-gen/web-secured/models/auth-support-type';
import {BadgeType} from '../../../../models/badge/badge-type';
import {BadgeProvider} from '../../../../models/badge/badge-provider';
import {AuthSupportState} from '../../../../../swagger-gen/web-secured/models/auth-support-state';
import {BadgeState} from '../../../../models/badge/badge-state';
import {BadgePageable} from '../../../../models/badge/badge-pageable';
import {AuthSupport} from '../../../../../swagger-gen/web-secured/models/auth-support';

// TODO: should be fixed directly in the swagger
export interface VnfAuthSupport extends AuthSupport {
    plcSlot?: number;
}

export class BadgeRepoModelMapper {

    static toList(authSupportPagedList: AuthSupportPagedList): BadgePageable {
        return {
            data: authSupportPagedList?.list?.map(item => BadgeRepoModelMapper.toBadge(item as VnfAuthSupport)) ?? [],
            pageable: {
                offset: authSupportPagedList?.paging?.offset ?? 0,
                totalSize: authSupportPagedList.paging.totalItems,
                pageSize: authSupportPagedList.paging.curItems,
            },
        };
    }

    static toBadge(authSupport: VnfAuthSupport): Badge {
        return {
            id: authSupport.uid,
            value: authSupport.value ?? '',
            type: BadgeRepoModelMapper.toType(authSupport.type),
            provider: authSupport.providersSync?.[0].provider ?? '',
            validityStart: moment(authSupport.validityStart).toDate(),
            validityEnd: moment(authSupport.validityEnd).toDate(),
            lastActivity: undefined,
            state: BadgeRepoModelMapper.toState(authSupport.state as AuthSupportState ),
            creation: moment(authSupport.auditor?.createdAt).toDate(),
            synchronized: authSupport.providersSync?.[0].syncState === 'SYNCHRONIZED',
            internalValue: authSupport.internalValue,
            reason: authSupport.reason ?? '',
            requestKM: authSupport.requestKM ?? false,
            secretCode: authSupport.secretCode,
            customerAccountId: authSupport.subscriptionUid,
            customerAccountName: authSupport.subscriptionName,
            plcSlot: authSupport.plcSlot ?? null,
            // ceiling: authSupport.ceiling,
            // driverCode: authSupport.driverCode,
            // langCode: authSupport.langCode,
            // parcNumber: authSupport.parcNumber,
            // plateNumber: authSupport.plateNumber,
            // service: authSupport.subServiceUid,
        };
    }

    private static toType(authSupportType: AuthSupportType = AuthSupportType.UNKNOWN): BadgeType {
        const typeMapping: Map<AuthSupportType, BadgeType> = new Map([
            [AuthSupportType.HID, BadgeType.HID],
            [AuthSupportType.LICENCE_PLATE, BadgeType.LICENCE_PLATE],
            [AuthSupportType.QR_CODE, BadgeType.QR_CODE],
            [AuthSupportType.RFID, BadgeType.RFID],
            [AuthSupportType.UNKNOWN, BadgeType.UNKNOWN],
        ]);

        return <BadgeType>typeMapping.get(authSupportType);
    }

    private static toProvider(authSupportProvider: any): BadgeProvider {
        const providerMapping: Map<any, BadgeProvider> = new Map([
            ['LAFON', BadgeProvider.LAFON],
            ['GIR_LAFON', BadgeProvider.GIR_LAFON],
            ['GIR', BadgeProvider.GIR],
            ['GIR_GNV', BadgeProvider.GIR_GNV],
            ['SOGESMATIC', BadgeProvider.SOGESMATIC],
            ['OTHER', BadgeProvider.OTHER],
        ]);

        return <BadgeProvider>providerMapping.get(authSupportProvider);
    }

    private static toState(authSupportState: AuthSupportState): BadgeState {
        const stateMapping: Map<AuthSupportState, BadgeState> = new Map([
            [AuthSupportState.ACTIVE, BadgeState.ACTIVE],
            [AuthSupportState.BLOCKED, BadgeState.RED_LIST],
            [AuthSupportState.REMOVED, BadgeState.BLACK_LIST],
        ]);

        return <BadgeState>stateMapping.get(authSupportState);
    }

}
